/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popFaceScan.vue?vue&type=template&id=6967b0a8&scoped=true"
import script from "./popFaceScan.vue?vue&type=script&lang=js"
export * from "./popFaceScan.vue?vue&type=script&lang=js"
import style0 from "./popFaceScan.vue?vue&type=style&index=0&id=6967b0a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6967b0a8",
  null
  
)

export default component.exports